import JobCard from './JobCard.react'

export default JobCard
